import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataLastNumValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'number',
            empty: false,
            mandatory: false
        };
    }
}
